import React from 'react';
import PropTypes from 'prop-types';
import SharedScript from '@americanexpress/shared-scripts';

const SessionManager = ({
  children,
}) => (
  <React.Fragment>
    <SharedScript
      name="one-identity-session"
      windowCheck="AmexSession"
      version="^1.2.0"
    />
    {children}
  </React.Fragment>
);

SessionManager.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SessionManager;
